module.exports = __webpack_public_path__ + "static/media/SCALE_Screen1.a7248ae1.png";